import { t } from "@travily/i18n";

// i18n-tasks-use t('components.relative_time.just_now')
// i18n-tasks-use t('components.relative_time.minutes_ago')
// i18n-tasks-use t('components.relative_time.hours_ago')
// i18n-tasks-use t('components.relative_time.days_ago')

/** Returns a human-readable relative time string for an ISO 8601 date string. */
export function formatRelativeTime(dateString: string): string {
  const now = Date.now();
  const date = new Date(dateString).getTime();
  const diffMs = now - date;
  const diffMinutes = Math.floor(diffMs / 60_000);
  const diffHours = Math.floor(diffMs / 3_600_000);
  const diffDays = Math.floor(diffMs / 86_400_000);

  if (diffMinutes < 1) return t("components.relative_time.just_now");
  if (diffMinutes < 60) return t("components.relative_time.minutes_ago", { count: diffMinutes });
  if (diffHours < 24) return t("components.relative_time.hours_ago", { count: diffHours });
  return t("components.relative_time.days_ago", { count: diffDays });
}
